<sb-dialog-activation
  [showTitle]="currentStep === AbsenceManagementDialogStep.TEASER"
  [showBackButton]="currentStep > 0 && currentStep !== AbsenceManagementDialogStep.SUMMARY"
  [showProgressBar]="currentStep > 0 && currentStep !== AbsenceManagementDialogStep.SUMMARY"
  [currentStep]="currentStep"
  [totalSteps]="steps"
  (back)="goBack()"
>
  <div main-panel>
    @switch (currentStep) {
      @case (AbsenceManagementDialogStep.TEASER) {
        <chapter-step
          [subtitle]="'Absence Management' | translate"
          [title]="'Streamline Absence Management for happier teams.' | translate"
          [nextButtonLabel]="'Show me a quick tour' | translate"
          (next)="close({ action: 'primary' })"
        >
          <div class="flex flex-col gap-1">
            <chapter-item
              [text]="'Automated balance tracking' | translate"
              [description]="'No guesswork, calculations done for you' | translate"
            />
            <chapter-item
              [text]="'No more spreadsheets' | translate"
              [description]="'Manage absences effortlessly without manual updates' | translate"
            />
            <chapter-item
              [text]="'Happier employees' | translate"
              [description]="'Simplified time-off requests via mobile with automatic notifications' | translate"
            />
            <chapter-item
              [text]="'Clear communication' | translate"
              [description]="'Real-time data reduces back-and-forth' | translate"
            />
          </div>
        </chapter-step>
      }
      @case (AbsenceManagementDialogStep.BASIC_SETUP) {
        <chapter-step
          [title]="'When an absence is approved, what should happen to scheduled shifts?' | translate"
          [nextButtonLoading]="nextButtonLoading"
          [nextButtonDisabled]="defaultRosterAction.invalid"
          (next)="savePreferences()"
        >
          <sb-radio-group [formControl]="defaultRosterAction" class="flex flex-col gap-2">
            @for (option of rosterActionOptions; track option.value) {
              <sb-radio
                class="p-1"
                [name]="'absence-management-default-roster-action'"
                [value]="option.value"
                [label]="option.label"
                [description]="option.description"
              />
            }
          </sb-radio-group>
          <p class="m-0 text-base">
            {{ 'This applies by default, but you can modify it per absence if needed.' | translate }}
          </p>
        </chapter-step>
      }
      @case (AbsenceManagementDialogStep.SUMMARY) {
        <chapter-step
          [title]="'🎉 ' + ('Great job! You\'re all set to manage absences and payroll with Shiftbase!' | translate)"
          [nextButtonLabel]="chapterCTAs?.primary?.label || 'Continue exploring' | translate"
          (next)="close({ action: 'primary' })"
        >
          <p class="m-0 text-base">
            {{
              'There is a lot more to discover about Absence Management like Time Off  balance expiration, National Holidays and more!'
                | translate
            }}
            <a
              [href]="'managing-absence' | knowledgeBaseArticleLink"
              target="_blank"
              class="font-bold text-brand"
              data-testid="article-link"
            >
              {{ 'Learn more' | translate }}
            </a>
          </p>
        </chapter-step>
      }
    }
  </div>
  <div
    class="flex size-full min-h-72 overflow-hidden rounded-lg bg-cover bg-center bg-no-repeat lg:mr-12"
    aside-panel
    [ngStyle]="{
      backgroundImage: 'url(assets/images/onboarding/chapters/absence-management.jpeg)',
    }"
  ></div>
</sb-dialog-activation>
